import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/rent-object-channels`, formData);
  },
  async findAll(formData) {
    return axios.get(`/rent-object-channels/rent-objects/${formData.id}`);
  },
  async synchronize(formData) {
    return axios.get(`/rent-object-channels/${formData.id}/rent-object/${formData.rentObjectId}/synchronize`);
  },
  async synchronizePictures(formData) {
    return axios.get(`/rent-object-channels/${formData.id}/rent-object/${formData.rentObjectId}/synchronize-pictures/${formData.deletePicturesPrior ? 'delete' : 'noDelete'}`);
  },
  async deleteTraumferienwohnungenImage(formData) {
    return axios.get(`/rent-object-channels/${formData.id}/rent-object/${formData.rentObjectId}/delete-traumferienwohnungen-picture/${formData.imageId}`);
  },
  async getPictures(formData) {
    return axios.get(`/rent-object-channels/${formData.id}/rent-object/${formData.rentObjectId}/get-pictures`);
  },
  async delete({ id }) {
    return axios.delete(`/rent-object-channels/${id}`);
  },
};
